import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";

export type AlertColor = "success" | "info" | "warning" | "error";

export interface GlobalMsgAlertStateType {
  duration?: number;
  msg: string;
  isAlert: boolean;
  color: AlertColor;
}

const initialState: GlobalMsgAlertStateType = {
  duration: 9000,
  msg: "MoleculeGen Alert Service",
  isAlert: false,
  color: "success",
};

const globalMsgAlerts = createSlice({
  name: "globalMsgAlerts",
  initialState,
  reducers: {
    closeGlobalMsgAlerts: (state, action) => {
      state.isAlert = false;
    },
    setGlobalMsgAlerts: (state, action) => {
      state.msg = action.payload.msg;
      state.isAlert = true;
      state.color = action.payload.color;
    },
  },
});

export const { closeGlobalMsgAlerts, setGlobalMsgAlerts } =
  globalMsgAlerts.actions;
export const selectGlobalMsgAlert = (state: RootState) => state.globalMsgAlerts;
export default globalMsgAlerts.reducer;
